import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import Header from "../components/layouts/Header";
import SideBar from "../components/layouts/Sidebar";
import { configCheck, getProfile } from "./commonAction";
import Authorization from "../utility/authorization";
import pusher from "../pusherConfig";
import { toast } from "react-toastify";
import "./common.scss";
import { Howl } from "howler";
import BookingToast from "./BookingToast";
import BookingToaster from "./BookingToaster";

// const bookingToaster = (data, eventType, history, closeToast) => {
//   try {
//     let soundSrc;
//     let toastSettings;
//     let toastMessage;
//     let closeOnClick = true;
//     let autoClose = false;
//     let closeButton = true;

//     if (eventType === "booking-create") {
//       soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
//       toastMessage = data.message;
//       toastSettings = {
//         progressClassName: "custom-progress-bar-booking",
//       };
//     } else if (eventType === "booking-cancel") {
//       soundSrc = [require("../assets/audios/booking-cancel.mp3")];
//       toastMessage = data.message;
//       toastSettings = {
//         progressClassName: "custom-progress-bar-error",
//       };
//     } else if (eventType === "booking-update") {
//       soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
//       toastMessage = (
//         <BookingToast
//           {...data}
//           closeOnClick={closeOnClick}
//           closeToast={closeToast}
//           history={history}
//         />
//       );
//       toastSettings = {
//         progressClassName: "custom-progress-bar-update",
//       };
//     }

//     const successSound = new Howl({
//       src: soundSrc,
//       autoplay: true,
//     });
//     successSound.play();
//     console.log({ qazwsx: data });

//     // toast.info(data.message, toastSettings);
//     toast.info(toastMessage, {
//       autoClose,
//       toastSettings,
//       closeButton,
//       closeOnClick,
//     });
//   } catch (error) {
//     console.error("Error playing audio or displaying toast:", error);
//   }
// };

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toastData: null,
      toastEventType: null,
    };
  }
  state = {
    companyInfo: {},
  };

  componentDidMount() {
    const storedData = localStorage.getItem("bookingData");
    const storedCancelData = localStorage.getItem("bookingCancelData");
    const storedUpdateData = localStorage.getItem("bookingUpdateData");
    if (storedData) {
      // Delay the execution of eventHandler by 3 seconds
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedData), "booking-create");
        // Clear the stored data after handling
        localStorage.removeItem("bookingData");
      }, 3000);
    }

    if (storedCancelData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedCancelData), "booking-cancel");
        localStorage.removeItem("bookingCancelData");
      }, 3000);
    }

    if (storedUpdateData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedUpdateData), "booking-update");
        localStorage.removeItem("bookingUpdateData");
      }, 3000);
    }

    this.props.isLoggedIn();

    this.channel = pusher.subscribe("taxida-bookings");
    this.channel.bind("booking-create", this.handleBookingCreate, this);
    this.channel.bind("booking-cancel", this.handleBookingCancel, this);
    this.channel.bind("booking-update", this.handleBookingUpdate, this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isFetching, response } = this.props.getProfileData;

    if (prevState.toastData !== null && prevState.toastEventType !== null) {
      this.setState({
        toastData: null,
        toastEventType: null,
      });
    }

    if (
      this.props.isLoggedIn() &&
      !isFetching &&
      response !== prevProps.getProfileData.response
    ) {
      const { status } = response;

      if (status >= 200 && status < 300) {
        this.setState({
          companyInfo: response,
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind("booking-create", this.eventHandler);
      this.channel.unbind("booking-cancel", this.handleBookingCancel);
      this.channel.unbind("booking-update", this.eventHandler);
      pusher.unsubscribe("taxida-bookings");
    }
  }

  handleBookingCreate = (data, eventType) => {
    const response = this.props.getProfileData.response || {};
    const operatingAreaInfo = response.operatingAreaInfo || [];

    // Extract operatingAreaId from the data received in the Pusher channel
    const { operatingAreaId } = data;

    // Check if the operatingAreaId exists in operatingAreaInfo
    const isOperatingAreaValid =
      Array.isArray(operatingAreaInfo) &&
      operatingAreaInfo.some(
        (area) => area.operatingAreaId === operatingAreaId
      );

    if (isOperatingAreaValid) {
      localStorage.setItem("bookingData", JSON.stringify(data));

      if (window.location.pathname === "/booking-list") {
        window.location.reload();
      } else {
        this.eventHandler(data, "booking-create");
        localStorage.removeItem("bookingData");
      }
    }
  };

  handleBookingCancel = (data) => {
    const { operatingAreaInfo } = this.props.getProfileData.response;

    const { operatingAreaId } = data;

    const isOperatingAreaValid = operatingAreaInfo.some(
      (area) => area.operatingAreaId === operatingAreaId
    );
    if (isOperatingAreaValid) {
      localStorage.setItem("bookingCancelData", JSON.stringify(data));

      // Check if the current URL is '/booking-list' and reload the page if so
      if (window.location.pathname === "/booking-list") {
        window.location.reload();
        // setTimeout(() => {
        //   this.eventHandler(data, "booking-cancel");
        // }, 3000);
      } else {
        // If not '/booking-list', proceed with event handling
        this.eventHandler(data, "booking-cancel");
        localStorage.removeItem("bookingCancelData");
      }
    }

    // if (isOperatingAreaValid) {
    //   localStorage.setItem("bookingCancelData", JSON.stringify(data));
    //   window.location.reload();
    //   // this.eventHandler(data, "booking-cancel");
    // }
  };

  handleBookingUpdate = (data) => {
    const { operatingAreaInfo } = this.props.getProfileData.response;

    const { operatingAreaId } = data;

    const isOperatingAreaValid = operatingAreaInfo.some(
      (area) => area.operatingAreaId === operatingAreaId
    );
    if (isOperatingAreaValid) {
      localStorage.setItem("bookingUpdateData", JSON.stringify(data));

      if (window.location.pathname === "/booking-list") {
        window.location.reload();
      } else {
        this.eventHandler(data, "booking-update");
        localStorage.removeItem("bookingUpdateData");
      }
    }
  };

  eventHandler = (data, eventType) => {
    this.setState(
      {
        toastData: data,
        toastEventType: eventType,
      },
      () => {
        this.setState({
          toastData: null,
          toastEventType: null,
        });
      }
    );
  };

  render() {
    const {
      component: Component,
      isLoggedIn,
      auth,
      authorizedPages,
      sidebar: { visible: isOpen },
      ...rest
    } = this.props;

    const { toastData, toastEventType } = this.state;

    const companyInfo = this.props.getProfileData.response;
    return (
      <Route
        {...rest}
        render={(props) => {
          return (
            <div className="main-body">
              {isLoggedIn() ? (
                <React.Fragment>
                  <Header
                    isLoggedIn={isLoggedIn}
                    auth={auth}
                    {...props}
                    companyInfo={companyInfo}
                  />
                  <SideBar isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  <div className={isOpen ? "content" : "content open"}>
                    <BookingToaster
                      data={toastData}
                      eventType={toastEventType}
                      history={this.props.history}
                    />
                    <Component
                      isLoggedIn={isLoggedIn}
                      auth={auth}
                      companyInfo={companyInfo}
                      {...props}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <Component
                  isLoggedIn={isLoggedIn}
                  auth={auth}
                  companyInfo={companyInfo}
                  {...props}
                />
              )}
            </div>
          );
        }}
      />
    );
  }
}

export default connect((state) => {
  return {
    sidebar: state.sidebar,
    configCheck: state.configCheck,
    getProfileData: state.getProfileData,
  };
})(Application);
